
export default {
    props: {
        availableSplits: Array, // Receive the availableSplits as a prop
        defaultValue: {
            type: Number,  
        },
    },
    data() {
        return {
            currentPosition: this.defaultValue ? this.availableSplits.indexOf(this.defaultValue) : 0 ,
            tickets: this.defaultValue ? this.defaultValue:  this.availableSplits[0],
            any_seat: false
        };
    },
    async mounted() {
        this.$nextTick(async () => {
            this.tickets = this.defaultValue ? this.defaultValue:  this.availableSplits[this.currentPosition]
            console.log('this.tickets '+ this.tickets)
        })
    },
    watch: {
        availableSplits(newVal) {
            this.tickets = this.defaultValue ? this.defaultValue:  this.availableSplits[this.currentPosition]
        }
    },
    methods: {
        handleOnClickSplit(value) {

            const index = this.currentPosition + value;

            if (index >= 0 && index < this.availableSplits.length) {
                this.currentPosition = this.currentPosition + value;
                this.tickets = this.availableSplits[this.currentPosition];
                this.$emit('ticket-updated', this.tickets); // Emit the updated value
            }
        },
        isNumber(event) {
            // Implement the isNumber function
        },
        searchOnKeyUp() {
            // Implement the searchOnKeyUp function
        }
    }
};
